import {useI18n, useIsRtl} from 'store/Store'
import {useNavigate} from 'services/hooks'
import {menuActions, menuIcons} from 'constants/sideMenu'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import MailIcon from '@mui/icons-material/Mail'
import {getSidebarStyles} from 'appearance/styles'

const getIcon = (text, index) =>
    menuIcons[text] || (index % 2 === 0 ? <InboxIcon /> : <MailIcon />)

const UseSideMenuItem = ({text, index, open, onClick}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()
    const navigate = useNavigate()
    const {iconStyle, textStyle} = getSidebarStyles(open, isRtl)
    const menuIcon = getIcon(text, index)

    const itemText = i18n.t(`menu.${text}`)
    const onClickInternal = () => {
        if (menuActions[text]) {
            menuActions[text](navigate)
        }
        onClick?.()
    }
    return {onClickInternal, iconStyle, textStyle, menuIcon, itemText}
}

export default UseSideMenuItem
